import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const mileageTrackingState = (state: RootState) => state.scene.dashboard.mileageTrackingState;

export const getMileageTrackingDrillDownViewState = createSelector(
  mileageTrackingState,
  ({ viewState }) => viewState
);

export const getMileageTrackingDrillDownTotalFilteredRecords = createSelector(
  mileageTrackingState,
  ({ totalFilteredRecords }) => totalFilteredRecords
);

export const getMileageTrackingDrillDownTotalRecords = createSelector(
  mileageTrackingState,
  ({ totalRecords }) => totalRecords
);

export const getMileageTrackingDrillDownCustomDateRange = createSelector(
  mileageTrackingState,
  ({ drillDownCustomDateRange }) => drillDownCustomDateRange
);

export const getMileageTrackingDrillDownConfiguration = createSelector(
  mileageTrackingState,
  ({ configuration }) => configuration
);

export const isMileageTrackingDrillDownLoading = createSelector(
  mileageTrackingState,
  ({ loading }) => loading
);
